import { TeeSelectableChip } from '@/components/ui/tee-selectable-chip';

export interface ClarifyChipsProps {
  options: string[];
  disabled?: boolean;
  onSelect: (label: string) => void;
}

const MAX_CHIPS = 6;

/** Tap-select chips for clarify options and quick replies. */
export function ClarifyChips({ options, disabled = false, onSelect }: ClarifyChipsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.slice(0, MAX_CHIPS).map((opt) => (
        <TeeSelectableChip
          key={opt}
          label={opt}
          selected={false}
          disabled={disabled}
          onClick={() => onSelect(opt)}
        />
      ))}
    </div>
  );
}
